var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaterproof = function SvgWaterproof(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 15,
    fill: "#3BE2E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#waterproof_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.006 17.827c-.657-1.122-1.354-1.083-2.011 0-3.018 4.488-7.583 11.219-7.583 14.585a8.6 8.6 0 0 0 2.515 6.073A8.6 8.6 0 0 0 29 41a8.6 8.6 0 0 0 6.074-2.515 8.6 8.6 0 0 0 2.515-6.073c0-3.405-4.565-10.097-7.583-14.585Zm5.184 18.415a7.345 7.345 0 0 1-2.592 2.514c-.503.271-1.122.116-1.392-.387-.31-.541-.116-1.16.386-1.431a5.12 5.12 0 0 0 1.857-1.78 5.043 5.043 0 0 0 .774-2.476c.039-.58.503-1.005 1.083-.967.58.039 1.006.503.967 1.084a7.664 7.664 0 0 1-1.083 3.443Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "waterproof_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17 17)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWaterproof;